<template>
  <div>
    <div
      :class="$vuetify.breakpoint.mobile ? 'flex-column mb-5' : 'justify-space-between'"
      class="d-flex"
    >
      <v-card-title
        class="titre-h3 mt-3 mb-3 ml-1"
      >
        Saisir la FAQ
      </v-card-title>
    </div>
    <div class="mt-2">
      <BaseLoader v-if="loading" />
      <FaqThemes
        :faq-themes="faqThemes"
        @saveTheme="saveTheme"
        @deleteTheme="deleteTheme"
        @deleteFaqQuestionReponse="deleteFaqQuestionReponse"
        @saveFaqQuestionReponse="saveFaqQuestionReponse"
      />
    </div>
  </div>
</template>
      
<script>
import FaqThemes from './components/faq-theme.vue'
import { mapActions, mapGetters } from 'vuex'
import BaseLoader from '@/components/common/base-loader.vue'

export default {
  name: 'FaqAdmin',
  components: { FaqThemes, BaseLoader },

  data () {
    return {
      loading: false,
      serverError: false
    }
  },

  computed: {
    ...mapGetters({
      faqThemes: 'faq/faqThemes'
    })

  },

  created () {
    this.loadThemes()
  },

  methods: {
    ...mapActions({
      getFaqThemes: 'faq/getFaqThemes',
      updateFaqTheme: 'faq/updateFaqTheme',
      deleteFaqTheme: 'faq/deleteFaqTheme',
      deleteQuestionReponse: 'faq/deleteFaqQuestionReponse',
      updateFaqQuestionReponse: 'faq/updateFaqQuestionReponse'
    }),

    loadThemes () {
      this.loading = true
      this.getFaqThemes()
        .catch(() => {
          this.serverError = true
        })
        .finally(() => this.loading = false)
    },

    saveTheme (themeASauvegarder) {
      this.loading = true
      this.updateFaqTheme(themeASauvegarder)
        .catch(() => {
          this.serverError = true
        })
        .finally(() => this.loading = false)
    },

    deleteTheme (themeASupprimer) {
      this.loading = true
      this.deleteFaqTheme(themeASupprimer)
        .catch(() => {
          this.serverError = true
        })
        .finally(() => this.loading = false)
    },

    deleteFaqQuestionReponse (questionReponseASupprimer) {
      this.loading = true
      this.deleteQuestionReponse(questionReponseASupprimer)
        .catch(() => {
          this.serverError = true
        })
        .finally(() => this.loading = false)
    },

    saveFaqQuestionReponse (questionReponseASauvegarder) {
      this.loading = true
      this.updateFaqQuestionReponse(questionReponseASauvegarder)
        .catch(() => {
          this.serverError = true
        })
        .finally(() => this.loading = false)
    }
  }
}
</script>

<style>
</style>